import LoadImgs from './loadImgs';
import webpUrl from './webpUrl';
import { utils as coreUtils } from '@didi/webx-js-core';
import CryptoJS from 'crypto-js';
import { get } from '../request';
/**
 * 加密
 */
async function setEncrypt(msg) {
    if (!msg)
        throw new Error('msg error');
    const str = typeof msg === 'string' ? msg : JSON.stringify(msg);
    const res = await getEncryptPublicKey();
    console.log('res:', res);
    const key = CryptoJS.enc.Utf8.parse(res);
    const srcs = CryptoJS.enc.Utf8.parse(str);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: key,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    const ciphertext = encrypted.ciphertext.toString();
    console.log('ciphertext:', ciphertext);
    // ///////
    let encryptedHexStr = CryptoJS.enc.Hex.parse(ciphertext);
    console.log('encryptedHexStr:', encryptedHexStr);
    return CryptoJS.enc.Base64.stringify(encryptedHexStr);
}
let ENCRYPY_PUBLIC_KEY = '';
/**
 * 获取密钥
 */
async function getEncryptPublicKey() {
    console.log('yes enter getEncryptPublicKey', ENCRYPY_PUBLIC_KEY);
    if (!ENCRYPY_PUBLIC_KEY) {
        const res = await get('//ut.xiaojukeji.com/ut/janitor/api/common/ciphersuite/get');
        console.log('getEncryptPublicKey res', res);
        if (+res.errno === 0) {
            ENCRYPY_PUBLIC_KEY = res.data.public_key;
            return ENCRYPY_PUBLIC_KEY;
        }
        else {
            throw new Error('failed to getEncryptPublicKey');
        }
    }
    return ENCRYPY_PUBLIC_KEY;
}
const utils = {
    ...coreUtils,
    setEncrypt,
    getEncryptPublicKey,
    LoadImgs,
    webpUrl
};
export { utils };
